export default {"src":"/_next/static/media/TECK.714873ae.svg","height":18,"width":18};